import { createFileRoute } from '@tanstack/react-router';
import { SwitchText } from '@thetreep/travel-ui';
import { useState } from 'react';

import { isMockMode, setMockMode } from '@/lib/mockMode';

export const Route = createFileRoute('/_static/dev')({
	component: DevPage,
});

function DevPage() {
	const [mockMode, setMockModeState] = useState(isMockMode);

	function handleMockModeChange(enabled: boolean | null) {
		const next = enabled ?? false;
		setMockMode(next);
		setMockModeState(next);
	}

	return (
		<div className="mx-auto min-h-[70vh] max-w-[640px] px-4 py-12">
			<h1 className="typography-title-l mb-8">Dev tools</h1>

			<section className="border-neutral-200 rounded-lg border p-6">
				<h2 className="typography-title-s mb-4">API</h2>
				<SwitchText
					label="Mock mode"
					description="Adds X-Mock-Mode: true to every API request"
					labelYes="On"
					labelNo="Off"
					isSelected={mockMode}
					onChange={handleMockModeChange}
				/>
			</section>
		</div>
	);
}
